import { useContext } from 'react';
import { InventoryFormModalContext } from '@/contexts/InventoryFormModalContext';

export const useInventoryFormModalContext = () => {
  const context = useContext(InventoryFormModalContext);

  if (!context) {
    throw new Error('useInventoryFormModalContext must be used within an InventoryFormModalContextProvider');
  }

  return context;
};

